import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button as MuiButton, styled, Typography } from '@mui/material';

import { StrengthTargetAssign } from '../../../types';

import AddSvgIcon from '../../../assets/SvgIcon/AddSvgIcon';

import StrengthCard from './StrengthCard';

const Container = styled('div')`
  height: calc(100% - 80px);
  width: 100%;
`;

const ContainerContent = styled('div')`
  height: 100%;
  width: 100%;
  border-radius: 4px;
  margin-top: 8px;
`;

const ContentTitle = styled(Typography)`
  color: white;
  margin-bottom: 8px;
`;

const Content = styled('div')`
  border-radius: 4px;
  height: 100%;
  width: 100%;
  overflow-y: auto;
  margin-top: 10px;
`;

const Button = styled(MuiButton)`
  text-transform: none;
  height: 40px;
  width: 100%;
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: start;
  align-items: center;
  color: white;
  &:hover {
    background: rgba(0, 0, 0, 0.1);
  }
`;

interface StrengthContentProps {
  handleStrengthAssign: (
    customStrengthTarget: Array<StrengthTargetAssign>,
  ) => void;
  data: Array<StrengthTargetAssign>;
}

const StrengthContent: React.VFC<StrengthContentProps> = ({
  handleStrengthAssign,
  data,
}) => {
  const { t } = useTranslation();
  const cards = data;

  const handleAddCard = () => {
    const initWorkerCard: StrengthTargetAssign = {
      name: '',
      mpa: undefined,
      id: '',
    };
    handleStrengthAssign([...cards, initWorkerCard]);
  };

  const onChangeCard = (index: number, datas: StrengthTargetAssign) => {
    const newDatas = [...cards];
    newDatas[index] = datas;
    handleStrengthAssign(newDatas);
  };

  const onDeleteCard = (index: number) => {
    const newcards = [...cards];
    newcards.splice(index, 1);
    handleStrengthAssign(newcards);
  };

  const items = cards.map((item, i) => (
    <StrengthCard
      key={i}
      onChange={onChangeCard}
      onDeleteCard={onDeleteCard}
      data={item}
      index={i}
    />
  ));

  return (
    <Container>
      <ContainerContent>
        <ContentTitle>
          {t('project-settingJson.navigator.custom-strength')}
        </ContentTitle>
        <Button
          startIcon={<AddSvgIcon sx={{ width: '32px', height: '32px' }} />}
          onClick={handleAddCard}
          disabled={cards.length >= 10}
        >
          {t('add-new-strength-target')}
        </Button>
        <Content>{items}</Content>
      </ContainerContent>
    </Container>
  );
};

export default StrengthContent;
